import { render, staticRenderFns } from "./WebsiteRoot.vue?vue&type=template&id=6a2d211b"
import script from "./WebsiteRoot.vue?vue&type=script&lang=ts"
export * from "./WebsiteRoot.vue?vue&type=script&lang=ts"
import style0 from "./WebsiteRoot.vue?vue&type=style&index=0&id=6a2d211b&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports